const getNumberValue = (value: number | string | undefined): number | undefined => {
  const convertedValue = Number(value);

  // Number() converts null, "", and " " to 0, which we don’t want
  if ((!value && value !== 0) || value === ' ' || Number.isNaN(convertedValue)) return undefined;

  return convertedValue;
};

export default getNumberValue;
